import "./DataTable.css";

const TablePagination = ({
  page,
  limit,
  total,
  count, // rows on the current page
  hasMore,
  loading,
  onPrev,
  onNext,
  noun = "results",
}) => {
  const from = total === 0 ? 0 : page * limit + 1;
  const to = Math.min(page * limit + count, total);
  const pages = Math.max(1, Math.ceil(total / limit));

  return (
    <div className="dt-pagination">
      <span className="dt-pagination__summary">
        {total === 0
          ? `No ${noun} found`
          : `Showing ${from}–${to} of ${total} ${noun}`}
      </span>

      <div className="dt-pagination__controls">
        <span className="dt-pagination__rows">Rows per page: {limit}</span>
        <button
          type="button"
          className="pag-btn"
          aria-label="Previous page"
          onClick={onPrev}
          disabled={page === 0 || loading}
        >
          <span className="material-symbols-outlined">chevron_left</span>
        </button>
        <span className="dt-pagination__page">
          Page {page + 1} of {pages}
        </span>
        <button
          type="button"
          className="pag-btn"
          aria-label="Next page"
          onClick={onNext}
          disabled={!hasMore || loading}
        >
          <span className="material-symbols-outlined">chevron_right</span>
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
